import { useState } from 'react';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { Title } from 'components/Title';

import axios from 'axios'; 
export default function OverduechargepostingPage() {
	
	const [pageReady, setPageReady] = useState(true);
	 const [postingDate, setPostingDate] = useState(new Date());
    const [frequency, setFrequency] = useState(null);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const frequencies = [
        { label: "Daily", value: "Daily" },
        { label: "Weekly", value: "Weekly" },
        { label: "Monthly", value: "Monthly" }
    ];
const fetchPreview = async (dryRun) => {
    setLoading(true);
    try {
        const token = localStorage.getItem("token");
        const url = `${process.env.REACT_APP_API_PATH}loan/charge-post?` +
            `PostingDate=${postingDate.toISOString().slice(0, 10)}` +
            `&FrequencyToProcess=${frequency}` +
            `&DryRun=${dryRun}`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            }
        });
        const result = await response.json();
        console.log("API RESULT:", result); // 🔥 Debug
        if (result.success) {
            setData(result.data);  // ✅ THIS WAS THE ISSUE
        } else {
            alert(result.message || "Failed");
        }
    } catch (err) {
        console.error(err);
        alert(err.message);
    } finally {
        setLoading(false);
    }
};
	return (
		<main id="OverduechargepostingPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title={$t('overduechargeposting')}   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <div className="p-4">
                        <h2>Overdue Charge Posting</h2>
                        <div className="p-grid mb-3">
                            <div className="p-col-4">
                                <Calendar value={postingDate} onChange={(e) => setPostingDate(e.value)} showIcon />
                            </div>
                            <div className="p-col-4">
                                <Dropdown value={frequency} options={frequencies}
                                onChange={(e) => setFrequency(e.value)} placeholder="Select Frequency" />
                            </div>
                            <div className="p-col-4">
                                <Button label="Preview" onClick={() => fetchPreview(true)} />
                                <Button label="Post" className="ml-2 p-button-danger" onClick={() => fetchPreview(false)} />
                            </div>
                        </div>
                        <DataTable value={data} loading={loading} paginator rows={10}>
                            <Column field="loanAccountNo" header="Loan" />
                                <Column field="period" header="EMI" />
                                    <Column field="overdueDays" header="Overdue Days" />
                                        <Column field="calculatedCharge" header="Charge" />
                                            <Column field="mode" header="Mode" />
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
		</main>
	);
}
